import React, { useState, useCallback, useEffect } from "react";
import { makeStyles, withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Switch from '@material-ui/core/Switch';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import services from '../services';
import { tagSchemaObject } from '../TagAmendmentSchema'
import { Fields, validateProperty, validate } from "../../Common"
import { PageHeader } from '../../../Common';
import Joi from '@hapi/joi'

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';

import IconButton from '@material-ui/core/IconButton';
import FormHelperText from '@material-ui/core/FormHelperText';

import MessageModal from '../../../UI/Modal/MessageModal';
import { truncate } from "lodash";

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 275,
        fontSize: 10,
    },
    title: {
        fontSize: 12,
    },
    btncolor: {
        background: '#10BA57'
    },
    btnroot: {
        backgroundColor: '#10BA57',
        borderRadius: 3,
        border: 0,
        color: 'white',
        height: '30px',
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        "&:hover": {
            //you want this to be the same as the backgroundColor above
            backgroundColor: "#049C44"
        }

    },
    card: {
        alignContent: 'center'
    },
    table: {
        minWidth: 650,
    },
}));



const FactoryGeneral = (props) => {

    const schema = Joi.object(tagSchemaObject).options({ allowUnknown: true })
    const classes = useStyles();
    const [errors, setErrors] = useState({});
    const [open, setOpen] = React.useState(false);
    const [groups, setGroups] = useState();
    const [factoriesData, setFactoriesData] = useState();
    const [customer, setCustomer] = useState([]);
    const [isCustomerEdit, setIsCustomerEdit] = useState(false);
    const [isDateEdit, setIsDateEdit] = useState(false);
    const [editPermissions, setEditPermissions] = useState({
        isCustomerEdit: false,
        isDateEdit: false,
        isDeductionEdit: false,
        isWeightEdit: false
    });
    const [activeFilter, setActiveFilter] = useState({
        groupID: "",
        operationEntityID: "",
        tag: "",
        date: ""
    });
    const [deductionTypes, setDeductionType] = useState([]);


    const [tagDetails, setTagDetails] = useState({
        date: "",
        grossWeight: "",
        routeName: "",
        tagReadTime: "",
        deductions: "",
        actualAmount: "",
        netAmount: "",
        mobileSessionID:"",
        collectionPointID:"",
        factoryWeighDeductions:[]
    });
    
    const [deductionFeilds, setDeductionFeild] = useState({
        deductionTypeID: "0",
        deductionAmount: ""
    });

    const [deductionArrays, setDeductionArrays] = useState({
        deletedFromOld: [],
        oldDeductions: [],
        newDeductions: []
    });

    const [newDate, setNewDate] = useState([]);

    const [customerInfo, setCustomerInfo] = useState({
        customerID: 0,
        cardNumber: "",
        customerNumber: ""
    });

    const [weightAttributes, setWeightAttibutes] = useState({
        totalWeight: "",
        grossWeight: "",
        netWeight: ""
    });

    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Success"
    })

    const [searchData, setSearchData] = useState({
        groupID: "",
        operationEntityID: "",
        tag: "",
        date: ""
    })

    useEffect(() => {
        setGroupDropDownData();
        getDeductionTypes();
        var datex = (new Date().toISOString()).split("T");
        setSearchData({
            date: datex[0]
        });

    }, []);

   

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, tagSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        setErrors(error);
    }

    async function setGroupDropDownData() {
        const result = await services.getGroupsForDropdown()
        setGroups(result)
    }
    
    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }
        setTimeout(() => {
            modalDismissHandler();
        }, 3000);
    }
    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    async function setDefaultWeightInfo() {
        setWeightAttibutes({
            ...weightAttributes,
            totalWeight: tagDetails.actualAmount,
            grossWeight: tagDetails.grossWeight,
            netWeight: tagDetails.netAmount
        })
    }

    async function setCustomerDefault() {
        setCustomerInfo({
            ...customerInfo,
            cardNumber: tagDetails.cardNo,
            customerNumber: tagDetails.customerNo,
        });
    }
    async function getDeductionTypes() {
        let res = await services.getDeductionTypes();
        console.log("resd", res);
        setDeductionType(res);
    }

    function renderTypesDropDown(data) {
        let items = []
        if (data != null) {
            data.map((item) => {
                items.push(<MenuItem key={item.deductionTypeID} value={item.deductionTypeID}>{item.deductionTypeName}</MenuItem>)
            })

        }
        return items;
    }

    async function getCustomers(collectionPointID) {
        let result = await services.getCustomersFromCollectionPoint(collectionPointID);
        // console.log("dat", result);
        setCustomer(result);
    }

  
    async function handleSwitchDateChange(e) {
        setEditPermissions({
            ...editPermissions,
            [e.target.name]: !editPermissions.isDateEdit
        });
    }

    async function handleSwitchWeightChange(e) {
        setEditPermissions({
            ...editPermissions,
            [e.target.name]: !editPermissions.isWeightEdit
        });
        await setDefaultWeightInfo();
    }

    async function handleSwitchDeductionChange(e) {
        setEditPermissions({
            ...editPermissions,
            [e.target.name]: !editPermissions.isDeductionEdit,
            isWeightEdit: !editPermissions.isDeductionEdit
        });
        if (!e.target.value) {
         
            setDeductionArrays({
                ...deductionArrays,
                oldDeductions: tagDetails.factoryWeighDeductions,
                newDeductions:[]
            })
        }

    }

 
    async function handleDeductionFeildChange(e) {
        setDeductionFeild({
            ...deductionFeilds,
            [e.target.name]: e.target.value

        });
    }

    async function handleWeightInfoChange(e) {
        setWeightAttibutes({
            ...weightAttributes,
            [e.target.name]: e.target.value

        });

    }

    async function handleDeleteOldRecord(item) {

        var dataArray = [];
        dataArray = deductionArrays.oldDeductions;
        var index = dataArray.findIndex(x => x.deductionTemplateID === item.deductionTemplateID);
        dataArray.splice(index, 1);



        var deletedArray = [];
        deletedArray = deductionArrays.deletedFromOld;
        deletedArray.push(item);

        setDeductionArrays({
            ...deductionArrays,
            oldDeductions: dataArray,
            deletedFromOld: deletedArray
        })
        //await CalculateWeighment(); 
    }
    async function handleDeleteNewRecord(id) {
        console.log("found itx", id);
        var dataArray = [];
        dataArray = deductionArrays.newDeductions;
        var index = dataArray.findIndex(x => x.deductionTemplateID === id);
        dataArray.splice(index, 1);
        setDeductionArrays({
            ...deductionArrays,
            newDeductions: dataArray
        });
    }
    async function saveToNewDeductionList(e) {
        let listarray = [];
        listarray = deductionArrays.newDeductions;

        let obj = deductionTypes.find(o => o.deductionTypeID === deductionFeilds.deductionTypeID);

        let form = {
            deductionTypeID: parseInt(deductionFeilds.deductionTypeID),
            deductionAmount: parseFloat(deductionFeilds.deductionAmount),
            deductionTypeName: obj.deductionTypeName
        }

        listarray.push(form);
        setDeductionArrays({
            ...deductionArrays,
            newDeductions: listarray
        });
    }

    function renderNewDeductions(data) {
        let items = [];
        if (data != null) {

            data.map((item) => {
                items.push(
                    <TableRow key={item.factoryWeighDeductionID}>
                        <TableCell component="th" align="center" scope="row">
                            {item.deductionTypeName}
                        </TableCell>
                        <TableCell align="center">{item.deductionAmount}</TableCell>
                        <TableCell align="center">
                            <IconButton aria-label="delete"
                                onClick={(item) => handleDeleteNewRecord(item.deductionTemplateID)}
                                className={classes.margin}>
                                <Icon>deleteForeverIcon </Icon>
                            </IconButton>
                        </TableCell>

                    </TableRow>
                )
            })

        }
        return items;
    }


    async function handleDateChange(e) {
        setNewDate(e.value);
    }

    async function handleSubmitApproval() {
        var totDeductions = CalculateWeighment();
      

        let formData = {
            factoryWeighmentAmendRequestID:0,
            factoryWeighDetailID:tagDetails.factoryWeighDetailID,
            collectionPointID:tagDetails.collectionPointID,
            mobileSessionID:tagDetails.mobileSessionID,
            oldFactoryWeighmentDetail:tagDetails,
            grossAmount: (Math.round(parseFloat(weightAttributes.totalWeight) )),
            actualAmount:parseFloat(weightAttributes.totalWeight) ,
            netAmount: (parseFloat(weightAttributes.totalWeight)-(totDeductions)),
            status : 1,
            tagNumber:tagDetails.tagNumber,
            totalDeduction:totDeductions,
            newDate : newDate,
            previouseDate : tagDetails.tagReadTime,
            deletedDeduction: deductionArrays.deletedFromOld,
            newDeduction: deductionArrays.newDeductions,
            oldDeduction: deductionArrays.oldDeductions,
            isDateChanged: editPermissions.isDateEdit,
            isWeightChanged: editPermissions.isWeightEdit,
            isDeductionChanged: editPermissions.isDeductionEdit,
            isActive:true,
            createdBy:1
        }
        console.log("formdd", formData);
        var response = await services.saveToFactoryApproval(formData);
        console.log("sttts", response);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)
    }

    function CalculateWeighment() {

        var totalDeduction = 0;
        deductionArrays.oldDeductions.map((row) => {
            totalDeduction = totalDeduction + parseFloat(row.deductionAmount);
        });

        deductionArrays.oldDeductions.map((row) => {
            totalDeduction = totalDeduction + parseFloat(row.deductionAmount);
        });

        return totalDeduction;
    }

    function renderDropDown(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items;
    }


    function handleGroupChange(target) {
        validateInputs(target);
        setSearchData({
            ...searchData,
            groupID: target.value
        });
        getOperationEntitiesForDropdown(target.value);
    }

    function handleOperationEntityChange(target) {
        validateInputs(target);
        setSearchData({
            ...searchData,
            operationEntityID: target.value,
        });
    }

    function handleSearchDateChange(target) {
        setSearchData({
            ...searchData,
            date: target.value,
        });
    }

    async function getOperationEntitiesForDropdown(groupID) {
        const opEntities = await services.getAllOperationEntitiesForDropDown(groupID);
        setFactoriesData(opEntities);
    }

    
    function handleTagChange(target) {
        validateInputs(target);
        setSearchData({
            ...searchData,
            tag: target.value,
        });
    }

    async function handleSubmit() {
        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        var response = await services.getFactoryTagDetails(searchData);
        if (response != null || response != undefined) {
          setTagDetails(response);
          setDeductionArrays({
              ...deductionArrays,
              oldDeductions:response.factoryWeighDeductions
          })
          setNewDate(((response.tagReadTime).split("T"))[0]);
          setWeightAttibutes({
              ...weightAttributes,
              grossWeight:response.grossAmount,
              netWeight:response.netAmount,
              totalWeight:response.actualAmount
          })
        }

    }

    return (
        <div >
            <Card >

                <CardContent>

                    <PageHeader
                        title={"Factory General Tag Amendment"}
                        isButtonEnable={false}
                        buttonText="Back to Listing"
                        path="/groups"
                    />


                    <Grid container spacing={3}>

                        <Grid item xs={3} >
                            <TextField
                                id="groupID"
                                name="groupID"
                                select
                                fullWidth
                                label="Group *"
                                value={searchData.groupID}
                                onChange={(e) => handleGroupChange(e.target)}
                            >
                                <MenuItem value="0">--Select Group Name--</MenuItem>
                                {renderDropDown(groups)}
                            </TextField>
                            {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                        </Grid>

                        <Grid item xs={3}>
                            <TextField
                                id="operationEntityID"
                                name="operationEntityID"
                                select
                                fullWidth
                                label="Factory *"
                                onChange={(e) => handleOperationEntityChange(e.target)}
                                value={searchData.operationEntityID}
                            >
                                <MenuItem value="0">--Select operationEntity Name--</MenuItem>
                                {renderDropDown(factoriesData)}
                            </TextField>
                            {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                        </Grid>

                        <Grid item xs={3}>
                            <TextField
                                id="tag"
                                name="tag"
                                fullWidth
                                label="TagNumber *"
                                onChange={(e) => handleTagChange(e.target)}
                                value={searchData.tag}

                            >
                            </TextField>
                            {errors["tag"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["tag"]}</FormHelperText>}
                        </Grid>


                        <Grid item xs={3}>
                            <TextField
                                id="date *"
                                fullWidth
                                type="date"
                                label="Date"

                                onChange={(e) => handleSearchDateChange(e.target)}
                                value={searchData.date}
                            >

                            </TextField>
                        </Grid>



                        <Grid container justify="flex-end">
                            <Button
                                onClick={() => handleSubmit()}
                                variant="contained"
                                className={classes.btnroot}
                            > Search</Button>
                        </Grid>


                    </Grid>

                    <br />
                  
                    <Card className={classes.root} variant="outlined">
                        <CardContent>
                            <Grid container spacing={3}>

                                <Grid item xs={1} justify="flex-end">
                                    <Switch
                                        color="primary"
                                        label="Edit"
                                        checked={editPermissions.isDateEdit}
                                        onChange={(event) => handleSwitchDateChange(event)}
                                        name="isDateEdit"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                </Grid>
                                <Grid item xs={2} justify="flex-start">
                                    <Chip label="Edit Date" />
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>

                                <Grid item xs={3}>
                                    <TextField
                                        id="newDate"
                                        name="newDate"
                                        variant="outlined"
                                        size='small'
                                        disabled={!editPermissions.isDateEdit}
                                        fullWidth
                                        type='date'
                                        label="Date*"
                                        onChange={(e) => handleDateChange(e.target)}
                                        value={newDate}

                                    >
                                    </TextField>

                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <br />
                    <Card className={classes.root} variant="outlined">
                        <CardContent>
                            <Grid container spacing={3}>
                                <Grid item xs={1} justify="flex-end">
                                    <Switch
                                        color="primary"
                                        label="Edit"
                                        checked={editPermissions.isWeightEdit}
                                        onChange={(event) => handleSwitchWeightChange(event)}
                                        name="isWeightEdit"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                </Grid>
                                <Grid item xs={2} justify="flex-start">
                                    <Chip label="Edit Weight" />
                                </Grid>
                            </Grid>

                            <Grid container spacing={3}>
                                <Grid item xs={3}>
                                    <TextField
                                        id="totalWeight"
                                        name="totalWeight"
                                        variant="outlined"
                                        disabled={!editPermissions.isWeightEdit}
                                        size='small'
                                        fullWidth
                                        label="Total Weight *"
                                        onChange={(e) => handleWeightInfoChange(e)}
                                        value={weightAttributes.totalWeight}

                                    >
                                    </TextField>

                                </Grid>

                            </Grid>
                        </CardContent>
                    </Card>
                    <br />
                    <Card className={classes.root} variant="outlined">
                        <CardContent>
                            <Grid container spacing={3}>

                                <Grid item xs={1} justify="flex-end">
                                    <Switch
                                        color="primary"
                                        label="Edit"
                                        checked={editPermissions.isDeductionEdit}
                                        onChange={(event) => handleSwitchDeductionChange(event)}
                                        name="isDeductionEdit"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                </Grid>
                                <Grid item xs={2} justify="flex-start">
                                    <Chip label="Edit Deductions" />
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>

                                <Grid item xs={3}>
                                    <TextField
                                        id="deductionTypeID"
                                        name="deductionTypeID"
                                        select
                                        disabled={!editPermissions.isDeductionEdit}
                                        variant="outlined"
                                        size='small'
                                        fullWidth
                                        label="Deduction Type"
                                        onChange={(e) => handleDeductionFeildChange(e)}
                                        value={deductionFeilds.deductionTypeID}
                                    >
                                        <MenuItem value="0">--Select Deduction Type--</MenuItem>
                                        {renderTypesDropDown(deductionTypes)}
                                    </TextField>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        id="deductionAmount"
                                        name="deductionAmount"
                                        disabled={!editPermissions.isDeductionEdit}
                                        variant="outlined"
                                        size='small'
                                        fullWidth
                                        label="Deduction Value"
                                        onChange={(e) => handleDeductionFeildChange(e)}
                                        value={deductionFeilds.deductionAmount}

                                    >
                                    </TextField>
                                </Grid>
                                <Grid item xs={3} justify="flex-end">
                                    <Button
                                        onClick={() => saveToNewDeductionList()}
                                        variant="contained"
                                        disabled={!editPermissions.isDeductionEdit}
                                        className={classes.btnroot}
                                        endIcon={<Icon>saveAltIcon </Icon>}

                                    >Add
                    </Button>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid disabled={!editPermissions.isDeductionEdit} item xs={8}>
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center">Deduction Name</TableCell>
                                                    <TableCell align="center">Value</TableCell>
                                                    <TableCell align="center">Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>

                                                {deductionArrays.oldDeductions.map((row) => (
                                                    <TableRow key={row.factoryWeighDeductionID}>
                                                        <TableCell align="center" component="th" scope="row">
                                                            {row.deductionTypeName}
                                                        </TableCell>
                                                        <TableCell align="center">{row.deductionAmount}</TableCell>
                                                        <TableCell align="center">
                                                            <IconButton aria-label="delete"
                                                                onClick={() => handleDeleteOldRecord(row)}
                                                                className={classes.margin}>
                                                                <Icon>deleteForeverIcon </Icon>
                                                            </IconButton>
                                                        </TableCell>

                                                    </TableRow>
                                                ))}


                                                {renderNewDeductions(deductionArrays.newDeductions)}

                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                </CardContent>

                <CardActions className={classes.card} alignContent={'right'}>
                    <Grid container justify="flex-end">
                        <Button
                            onClick={() => handleSubmitApproval()}
                            variant="contained"
                            className={classes.btnroot}
                        > Update</Button>&nbsp;
                                       </Grid>

                </CardActions>
            </Card>


            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />

        </div>
    );

}
export default FactoryGeneral;
